export type FormValues = {
  scriptingSource: string;
  subscribeUrl: string;
  unsubscribeUrl: string;
};

export const fieldTemplates = [
  {
    label: 'Scripting.js',
    key: 'scriptingSource',
    type: 'code-editor',
    maxLines: 38,
    help_text_html:
      'Edit your integration’s custom JavaScript code from Zapier’s legacy web builder to customize API calls, HTTP headers, data parsing, and more. <a href="https://docs.zapier.com/platform/reference/legacy-scripting" target="_blank">Learn more</a>.',
  },
  {
    label: 'Subscribe URL',
    key: 'subscribeUrl',
    type: 'single-line-string',
    helpText: 'Enter the endpoint URL to create a new webhook subscription.',
    needs: (values: FormValues) => typeof values.subscribeUrl === 'string',
  },
  {
    label: 'Unsubscribe URL',
    key: 'unsubscribeUrl',
    type: 'single-line-string',
    helpText: 'Enter the endpoint URL to delete a webhook subscription.',
    needs: (values: FormValues) => typeof values.unsubscribeUrl === 'string',
  },
];
